/**
 * Bound a `?redirect=` query value to a path inside this app.
 *
 * The auth screens send the user wherever `?redirect=` points once they have
 * consented / verified. The router only ever writes `to.fullPath` there, but
 * the value arrives from the URL, so anyone can hand a user a link to one of
 * those screens with an off-site target — an open redirect handed a freshly
 * authenticated user, which is exactly the shape phishing wants.
 *
 * Anything that is not plainly a relative in-app path is refused in favour of
 * the fallback. In particular `//host` and `/\host` are refused: both leave
 * the origin, and neither looks like it does.
 */
export function safeInAppPath(value: unknown, fallback = '/'): string {
  if (typeof value !== 'string' || value === '') return fallback

  // Browsers strip tabs and newlines before parsing a URL, so a value must
  // never be judged on a written form that differs from what gets parsed.
  if (/[\u0000-\u001f\u007f]/.test(value)) return fallback

  if (!value.startsWith('/')) return fallback
  if (value.startsWith('//')) return fallback
  if (value.includes('\\')) return fallback

  return value
}
